import { Model } from "pinia-orm";

export default class DocumentStatus extends Model {
  static name = "DocumentStatus";
  static entity = "documentStatus";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(),
      name: this.attr(),
    };
  }
}
